import CandidateForm from "../../components/CandidateForm";

const CreateCandidateScreen = () => {
  return <CandidateForm />;
};

export default CreateCandidateScreen;
